export const PRESET_FILTERS = {
  ASSIGNED_TO: 'assignedTo',
  REPORTED_BY: 'reportedBy',
} as const;
